const baseURL = '/locations';

import memoize from 'lodash/memoize';

const autocomplete = memoize((q, address, countryOnly) => {
    return axios
        .get(`${baseURL}/autocomplete`, {
            params: {
                q,
                address,
                countryOnly,
            },
        })
        .then(R.prop('data'));
});

function getAddress({ lat, lng }) {
    const uri = `${baseURL}/geocode`;
    return axios
        .get(uri, {
            params: {
                lat,
                lng,
            },
        })
        .then(R.prop('data'));
}

function getCoordinates(id) {
    const uri = `${baseURL}/details`;
    return axios
        .get(uri, {
            params: {
                id,
            },
        })
        .then(R.prop('data'));
}

export default {
    autocomplete,
    getAddress,
    getCoordinates,
};
